// extracted by mini-css-extract-plugin
export default {"Video":"Video_Video__hSoVg","videoContainer":"Video_videoContainer__c4ids"};